(function () {
  'use strict';

  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  var itemsEl = drawer.querySelector('[data-cart-drawer-items]');
  var emptyEl = drawer.querySelector('[data-cart-drawer-empty]');
  var footerEl = drawer.querySelector('[data-cart-drawer-footer]');
  var drawerCountEl = drawer.querySelector('[data-cart-drawer-count]');
  var subtotalEl = drawer.querySelector('[data-cart-drawer-subtotal]');
  var countEls = document.querySelectorAll('[data-cart-count]');
  var isUpdating = false;

  function getRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function getCartUrl() {
    return getRoot() + 'cart.js';
  }

  function getCartAddUrl() {
    return getRoot() + 'cart/add.js';
  }

  function getCartChangeUrl() {
    return getRoot() + 'cart/change.js';
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      var format =
        (window.theme && window.theme.moneyFormat) ||
        '${{amount}}';

      return Shopify.formatMoney(cents, format);
    }

    var dollars = cents / 100;
    return '$' + dollars.toLocaleString('en-US', {
      minimumFractionDigits: dollars % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    });
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function updateCounts(count) {
    countEls.forEach(function (el) {
      el.textContent = count;

      if (count > 0) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    });

    if (drawerCountEl) drawerCountEl.textContent = count;

    var fab = document.querySelector('.cart-drawer__fab');
    if (fab) {
      fab.setAttribute('aria-label', 'Open cart (' + count + ' items)');
    }
  }

  function renderItems(cart) {
    if (!itemsEl) return;

    if (!cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = '';
      if (emptyEl) emptyEl.removeAttribute('hidden');
      if (footerEl) footerEl.setAttribute('hidden', '');
      return;
    }

    if (emptyEl) emptyEl.setAttribute('hidden', '');
    if (footerEl) footerEl.removeAttribute('hidden');

    itemsEl.innerHTML = cart.items
      .map(function (item) {
        var variant =
          item.variant_title && item.variant_title !== 'Default Title'
            ? '<p class="cart-drawer__item-variant">' +
              escapeHtml(item.variant_title) +
              '</p>'
            : '';

        var image = item.image
          ? '<img src="' +
            escapeHtml(item.image) +
            '" alt="' +
            escapeHtml(item.product_title || item.title) +
            '" loading="lazy" width="72" height="72">'
          : '';

        return (
          '<li class="cart-drawer__item" data-line-key="' +
          escapeHtml(item.key) +
          '">' +
          '<a class="cart-drawer__item-media" href="' +
          escapeHtml(item.url) +
          '">' +
          image +
          '</a>' +
          '<div class="cart-drawer__item-details">' +
          '<a class="cart-drawer__item-title" href="' +
          escapeHtml(item.url) +
          '">' +
          escapeHtml(item.product_title || item.title) +
          '</a>' +
          variant +
          '<div class="cart-drawer__item-qty">' +
          '<button type="button" data-qty-change="-1" aria-label="Decrease quantity">−</button>' +
          '<span data-qty-display>' +
          item.quantity +
          '</span>' +
          '<button type="button" data-qty-change="1" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<button type="button" class="cart-drawer__item-remove" data-remove-item>Remove</button>' +
          '</div>' +
          '<p class="cart-drawer__item-price">' +
          formatMoney(item.final_line_price) +
          '</p>' +
          '</li>'
        );
      })
      .join('');

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  }

  function refreshCart() {
    return fetch(getCartUrl(), {
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to fetch cart');
        return response.json();
      })
      .then(function (cart) {
        updateCounts(cart.item_count);
        renderItems(cart);
        return cart;
      });
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
    refreshCart();

    var closeBtn = drawer.querySelector('.cart-drawer__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
  }

  function changeQuantity(key, quantity) {
    if (isUpdating) return;
    isUpdating = true;

    fetch(getCartChangeUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      })
      .then(function (cart) {
        updateCounts(cart.item_count);
        renderItems(cart);
        document.dispatchEvent(
          new CustomEvent('cart:refresh', { detail: cart, bubbles: true })
        );
      })
      .catch(function (error) {
        var message =
          (error && error.description) ||
          (error && error.message) ||
          'Unable to update cart.';
        alert(message);
      })
      .finally(function () {
        isUpdating = false;
      });
  }

  function notifyAdded(openAfterAdd) {
    refreshCart().then(function () {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

      if (openAfterAdd !== false) {
        openDrawer();
      }
    });
  }

  function handleAddResponse(response, openAfterAdd) {
    return response.json().then(function (data) {
      if (!response.ok) throw data;
      notifyAdded(openAfterAdd);
      return data;
    });
  }

  window.SSTCart = {
    refresh: refreshCart,
    open: openDrawer,
    close: closeDrawer,
    notifyAdded: notifyAdded,
  };

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      openDrawer();
      return;
    }

    if (e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn && drawer.contains(qtyBtn)) {
      e.preventDefault();
      var item = qtyBtn.closest('.cart-drawer__item');
      var key = item && item.dataset.lineKey;
      var display = item && item.querySelector('[data-qty-display]');
      if (!key || !display) return;

      var delta = parseInt(qtyBtn.dataset.qtyChange, 10);
      var newQty = Math.max(0, parseInt(display.textContent, 10) + delta);
      changeQuantity(key, newQty);
      return;
    }

    var removeBtn = e.target.closest('[data-remove-item]');
    if (removeBtn && drawer.contains(removeBtn)) {
      e.preventDefault();
      var removeItem = removeBtn.closest('.cart-drawer__item');
      if (removeItem) changeQuantity(removeItem.dataset.lineKey, 0);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  document.addEventListener('cart:refresh', function () {
    refreshCart();
  });

  document.addEventListener('cart:added', function (e) {
    var openAfterAdd = !e.detail || e.detail.openDrawer !== false;
    notifyAdded(openAfterAdd);
  });

  document.addEventListener('cart:open', function () {
    openDrawer();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;

    if (e.defaultPrevented) return;
    if (!form || !form.action || form.dataset.cartAjax === 'false') return;
    if (form.action.indexOf('/cart/add') === -1) return;
    if (!window.fetch) return;

    e.preventDefault();

    var submitBtn = form.querySelector('[type="submit"]');
    var label = submitBtn ? submitBtn.textContent.trim() : '';

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding…';
    }

    fetch(getCartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json',
      },
      body: new URLSearchParams(new FormData(form)).toString(),
    })
      .then(function (response) {
        return handleAddResponse(response, true);
      })
      .then(function () {
        if (submitBtn) submitBtn.textContent = '✓ Added!';
      })
      .catch(function (error) {
        var message =
          (error && error.description) ||
          (error && error.message) ||
          'Unable to add this item to your cart. Please try again.';
        alert(message);
      })
      .finally(function () {
        if (submitBtn) {
          setTimeout(function () {
            submitBtn.textContent = label;
            submitBtn.disabled = false;
          }, 1500);
        }
      });
  });

  refreshCart();
})();
